import { heroStats } from '@/mocks/homeData';

function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20warm%20toned%20quiet%20office%20interior%20at%20dusk%2C%20blurred%20wooden%20desk%20and%20tall%20window%20silhouette%2C%20soft%20golden%20light%20rays%2C%20deep%20amber%20and%20terracotta%20color%20palette%2C%20moody%20editorial%20photography%20with%20generous%20negative%20space%2C%20no%20text%2C%20high%20detail&width=1920&height=1080&seq=secretary-hero-2026&orientation=landscape"
          alt=""
          className="h-full w-full object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/50 to-foreground-950/75"></div>

      <div className="relative mx-auto w-full max-w-[1240px] px-4 pb-14 pt-40 md:px-6 md:pb-20 md:pt-48">
        <div className="max-w-3xl animate-fadeUp">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-3 py-1.5 font-label text-xs text-background-50 backdrop-blur">
            <i className="ri-quill-pen-line text-sm" aria-hidden="true"></i>
            中文字幕 · 译制版本 · 字幕在线
          </span>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-background-50 sm:text-4xl md:text-5xl">
            善良的女秘书 中文字幕与译制版本导览
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
            这一页把《善良的女秘书》的中文字幕、字幕在线、中文版与国语版集中整理在一起，
            并用分集状态、字幕组来源与观看指南帮你快速判断「该看哪一版、怎么对上画面」。
            所有内容均可在本页直接阅读，无需跳转。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              onClick={() => scrollToId('versions')}
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-stack-line text-base" aria-hidden="true"></i>
              查看版本速览
            </button>
            <button
              type="button"
              onClick={() => scrollToId('episodes')}
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-background-50/15"
            >
              <i className="ri-list-check-2 text-base" aria-hidden="true"></i>
              浏览分集字幕
            </button>
          </div>
        </div>

        <dl className="mt-12 grid grid-cols-2 gap-3 md:mt-16 md:grid-cols-4 md:gap-5">
          {heroStats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-50/15 bg-background-50/10 px-4 py-4 backdrop-blur"
            >
              <dt className="font-heading text-2xl font-bold text-accent-300 md:text-3xl">
                {stat.value}
              </dt>
              <dd className="mt-1 text-xs text-background-100/80 md:text-sm">{stat.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}